import { type RefObject } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

export const useTranscriptSearchHotkeys = ({
  inputRef,
  onSetPrevIndex,
  onSetNextIndex,
}: {
  inputRef: RefObject<HTMLInputElement>;
  onSetNextIndex?: () => void;
  onSetPrevIndex?: () => void;
}) => {
  useHotkeys(
    'ctrl+f,meta+f',
    () => {
      inputRef.current?.focus();
    },
    {
      enableOnFormTags: true,
      preventDefault: true,
    },
  );

  useHotkeys(
    'enter',
    () => {
      if (document.activeElement === inputRef.current) {
        onSetNextIndex?.();
      }
    },
    {
      enabled: !!onSetNextIndex,
      enableOnFormTags: true,
    },
  );

  useHotkeys(
    'shift+enter',
    () => {
      if (document.activeElement === inputRef.current) {
        onSetPrevIndex?.();
      }
    },
    {
      enabled: !!onSetPrevIndex,
      enableOnFormTags: true,
    },
  );

  useHotkeys(
    'meta+g,ctrl+g',
    () => {
      onSetNextIndex?.();
      inputRef.current?.focus();
    },
    {
      enabled: !!onSetNextIndex,
      enableOnFormTags: true,
      preventDefault: true,
    },
  );

  useHotkeys(
    'meta+shift+g,ctrl+shift+g',
    () => {
      onSetPrevIndex?.();
      inputRef.current?.focus();
    },
    {
      enabled: !!onSetPrevIndex,
      enableOnFormTags: true,
      preventDefault: true,
    },
  );
};
